import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=54d28c6f"
import script from "./eventEdit.js?vue&type=script&lang=js&external"
export * from "./eventEdit.js?vue&type=script&lang=js&external"
import style0 from "./EventEdit.vue?vue&type=style&index=0&id=54d28c6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports